/* Supra deprecated - please use formik app/assets/javascripts/react/shared/components/formik/components/inputs/Text/index.jsx */
/*
  eslint-disable
    jquery/no-closest,
    jquery/no-data,
    jquery/no-each,
    jquery/no-find
 */

import PropTypes from 'prop-types';
import { Component } from 'react';

import withDefaultAppContexts from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

import CustomizableAttribute from './CustomizableAttribute';
import InputCustomAttributeDate from './InputDateRange';

class InputsCustomAttributes extends Component {
  state = {
    customizableAttributes: [],
  };

  componentDidMount() {
    const { onFetchCustomAttributes } = this.props;

    /**
     * We disable the "asynchronous select field" behavior in back-end because
     * this component can be used in a context other than a Design System.
     */
    axios
      .get(
        Routes.customizable_attributes_groups_path({
          enable_asynchronous_select_field: false,
        }),
      )
      .then((response) => {
        this.setState(
          {
            customizableAttributes: response.data,
          },
          () => {
            this.setupInputs();
            onFetchCustomAttributes();
          },
        );
      });
  }

  setupInputs = () => {
    const { onChange } = this.props;

    // eslint-disable-next-line no-undef
    $(this.container)
      .find(
        '.js-user-customizable-attribute-boolean, .js-user-customizable-attribute-select',
      )
      .each((i, el) => {
        // eslint-disable-next-line no-undef
        const $el = $(el);
        const $dialog = $el.closest('dialog');
        const config = $el.data('select-config') || {};
        const select2Config = {
          ...($dialog.length ? { dropdownParent: $dialog } : {}),
          width: '100%',
        };

        if (config.remote) {
          select2Config.ajax = {
            url: Routes.search_customizable_attribute_select_path(),
            dataType: 'JSON',
            data: (term) => ({
              network_id: config.network_id,
              customizable_attribute_id: config.customizable_attribute_id,
              ...term,
            }),
            processResults: (data) => ({
              more: false,
              results: data.map((val) => ({ id: val, text: val })),
            }),
          };
        }
        $el.select2(select2Config).on('change', onChange);
      });

    // eslint-disable-next-line no-undef
    dynamic_attributes_double_select('[data-double-select-options]', {
      search_mode: true,
      display_placeholder: true,
      display_label: false,
      onChange,
    });
  };

  // RENDERERS

  renderAttributesGroup = (attributes) =>
    attributes.reduce((res, attr) => {
      if (attr.user_can_search) {
        if (attr.type === 'customizable_attribute_date') {
          const { id, name, tooltip, display_name: displayName } = attr;

          res.push(
            <InputCustomAttributeDate
              attrId={id}
              key={id}
              name={name}
              displayName={displayName}
              tooltip={tooltip}
              onChange={this.props.onChange}
            />,
          );
        } else {
          res.push(
            <CustomizableAttribute
              customizableAttribute={attr}
              key={attr.id}
            />,
          );
        }
      }

      return res;
    }, []);

  renderCustomAttributes = () => {
    const { customAttributes, types } = this.props;
    const { customizableAttributes } = this.state;

    const inputs = types
      .map((type) =>
        customizableAttributes[`${type}_customizable_attributes_groups`]?.map(
          (customGroup) =>
            this.renderAttributesGroup(customGroup.customizable_attributes),
        ),
      )
      .flat();

    if (customAttributes) {
      inputs.push(this.renderAttributesGroup(customAttributes));
    }

    return inputs.filter(Boolean).flat();
  };

  render() {
    return (
      <div
        ref={(ref) => {
          this.container = ref;
        }}
      >
        {this.renderCustomAttributes()}
      </div>
    );
  }
}

InputsCustomAttributes.propTypes = {
  types: PropTypes.array,
  customAttributes: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  onFetchCustomAttributes: PropTypes.func,
};

InputsCustomAttributes.defaultProps = {
  types: ['user', 'experience', 'education'],
  onFetchCustomAttributes: () => undefined,
};

export default withDefaultAppContexts(InputsCustomAttributes);
